// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"radial-chart_wrapper__yzoNH","big":"radial-chart_big__PMdNR","innerCircle":"radial-chart_innerCircle__jRNl4","outerCircle":"radial-chart_outerCircle__n1xUD"};